import Main from "./Pages/Main";
import Team from "./Pages/Team";
import Inductions from "./Pages/Inductions";
import { Routes, Route, HashRouter } from "react-router-dom";

function App()
{
  return(
    <HashRouter>
      <Routes>
        <Route path = "/" element = { <Main /> } />
        <Route path = "/team" element = { <Team /> } />
        <Route path = "/inductions" element = { <Inductions /> } />
      </Routes>
    </HashRouter>
  )
}

export default App;